import { memo, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import {
    Avatar,
    Button,
    Dropdown,
    DropdownItem,
    Header,
    HeaderBrand,
    HeaderNavigation,
    HeaderWidgets,
    NavItem,
    ToggleButton,
} from '@flixbus/honeycomb-react';
import { Icon, IconLogout, IconProfile } from '@flixbus/honeycomb-icons-react';
import { login, logout } from '../../helpers/auth';

const ProfileAvatar = () => (
    <Avatar>
        <Icon InlineIcon={IconProfile} size="cover" fillCanvas aria-hidden="true" />
    </Avatar>
);

const UserMenu = ({ account }) => {
    const [expanded, setExpanded] = useState(false);

    if (!account) {
        return (
            <Button noWrap appearance="link" onClick={login}>
                <ProfileAvatar />
                Login
            </Button>
        );
    }

    return (
        <Dropdown
            xPosition="left"
            onToggle={setExpanded}
            links={[
                <DropdownItem key="logout" Elem="button" InlineIcon={IconLogout} onClick={logout}>
                    Logout
                </DropdownItem>,
            ]}
        >
            <ToggleButton noWrap iconSize="M" appearance="link" aria-expanded={expanded} data-dd-privacy="mask">
                <ProfileAvatar />
                {account.name || ''}
            </ToggleButton>
        </Dropdown>
    );
};

const AppHeader = () => {
    const { accounts } = useMsal();
    const account = accounts[0];
    const { pathname } = useLocation();

    const isActive = (href) => (href === '/' ? pathname === href : pathname.startsWith(href));

    return (
        <Header
            fixed
            widgetSize="l"
            brand={
                <HeaderBrand
                    alt="Flixbus"
                    href="/"
                    src="https://honeycomb-assets.hive.flixbus.com/honeycomb-logos-static/1.0.1/svg/flixbus-white.svg"
                    width="126"
                    height="24"
                    RouterLink={NavLink}
                />
            }
            navigation={
                account && (
                    <HeaderNavigation aria-label="Main">
                        {/* honeycomb passes the props of NavItem to the RouterLink as they are, so it needs `to`. */}
                        <NavItem to="/" RouterLink={NavLink} active={isActive('/')}>
                            Search
                        </NavItem>
                        <NavItem to="/requests" RouterLink={NavLink} active={isActive('/requests')}>
                            Requests
                        </NavItem>
                    </HeaderNavigation>
                )
            }
            widgets={
                <HeaderWidgets>
                    <nav aria-label="User menu">
                        <UserMenu account={account} />
                    </nav>
                </HeaderWidgets>
            }
        />
    );
};

export default memo(AppHeader);
